import type * as React from 'react';
import { get } from '@Domain/Api';
import facilityTemplateOverridesFetched, {
	type FacilityTemplateOverridesFetchedAction,
	type FacilityTemplateOverridesFetchedPayload,
} from '@Application/Documents/TemplateAssignments/Actions/facilityTemplateOverridesFetched';
import facilityTemplateOverridesFetchFailed, {
	type FacilityTemplateOverridesFetchFailedAction,
} from '@Application/Documents/TemplateAssignments/Actions/facilityTemplateOverridesFetchFailed';
import type FetchFacilityTemplateOverrides from '@Application/Documents/TemplateAssignments/Queries/FetchFacilityTemplateOverrides';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = FacilityTemplateOverridesFetchedAction | FacilityTemplateOverridesFetchFailedAction;

export default (query: FetchFacilityTemplateOverrides) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<FacilityTemplateOverridesFetchedPayload>(
				`${parameters.api.host}/api/organizations/${query.organizationId}/facility-template-overrides`,
			);

			const action = facilityTemplateOverridesFetched(payload, query.organizationId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = facilityTemplateOverridesFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
